import React from 'react'
import { Theme, makeStyles } from '@material-ui/core/styles'
import { Typography, TextField } from '@material-ui/core'

type TextInputProps = {
  label: string
  value: string | number
  required: boolean
  placeholder: string
  type: React.InputHTMLAttributes<unknown>['type']
  onChange: (value: string) => void
  error?: string
  width?: number
  min?: number
  max?: number
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderRadius: 10,
  },
  input: {
    background: 'white',
    fontSize: 14,
    fontFamily: 'Poppins',
  },
  textField: {
    maxWidth: 380,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 320,
    },
  },
}))

function TextInput({ type = 'text', ...props }: TextInputProps) {
  const classes = useStyles()
  const handleKeyTyped = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (e.target?.value?.length === 0) {
      props.onChange(e.target.value)
      return
    }
    if (type === 'tel' || type === 'number') {
      const regex = /^[0-9]*$/
      const match = e.target?.value?.match(regex)
      const newValue = parseInt(e.target?.value)
      if (!match) {
        return
      }
      if (isNaN(newValue) || (props.max && newValue > props.max)) {
        return
      }
    }
    props.onChange(e.target.value)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Typography gutterBottom style={{ marginBottom: 10 }}>
        {props.label}
        {props.required && '*'}
      </Typography>
      <TextField
        InputProps={{
          classes: { notchedOutline: classes.root, root: classes.input },
        }}
        variant="outlined"
        type={type}
        placeholder={props.placeholder}
        required={props.required}
        value={props.value}
        onChange={handleKeyTyped}
        helperText={props.error}
        error={props.error !== undefined}
        className={classes.textField}
      />
    </div>
  )
}

export default TextInput
